import { render } from "./Search.vue?vue&type=template&id=600f2d8e"
const script = {}

import "./Search.vue?vue&type=style&index=0&id=600f2d8e&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__